import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import React from "react";
import {SearchInputArea} from "../search-input-area/search-input-area";
import {SearchInputFormBox} from "./boxes/search-input-form/search-input-form.box";
import {SearchPCIconBox} from "./boxes/search-pc-icon/search-pc-icon.box";
import {observer} from "mobx-react";

@observer
export class SearchInputPCComponent extends OrbitComponent<{}> {
    render() {
        return (
            <SearchInputFormBox>
                <SearchInputArea/>
                <SearchPCIconBox/>
            </SearchInputFormBox>
        );
    }
}